import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';
import { PaymentUtilService } from '../payment';

import {
    InvoiceService,
    InvoicePopupService,
    InvoiceComponent,
    InvoiceDialogComponent,
    InvoiceRequestDialogComponent,
    InvoicePopupComponent,
    InvoiceRequestPopupComponent,
    InvoiceDeletePopupComponent,
    InvoiceDeleteDialogComponent,
    InvoiceFinalizePopupComponent,
    InvoiceFinalizeDialogComponent,
    InvoiceReversePopupComponent,
    InvoiceReverseDialogComponent,
    InvoiceRoute,
    InvoicePopupRoute,
    InvoiceResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...InvoiceRoute,
    ...InvoicePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        InvoiceComponent,
        InvoiceDialogComponent,
        InvoiceRequestDialogComponent,
        InvoiceDeleteDialogComponent,
        InvoiceFinalizeDialogComponent,
        InvoiceReverseDialogComponent,
        InvoicePopupComponent,
        InvoiceRequestPopupComponent,
        InvoiceDeletePopupComponent,
        InvoiceFinalizePopupComponent,
        InvoiceReversePopupComponent
    ],
    entryComponents: [
        InvoiceComponent,
        InvoiceDialogComponent,
        InvoiceRequestDialogComponent,
        InvoicePopupComponent,
        InvoiceRequestPopupComponent,
        InvoiceDeleteDialogComponent,
        InvoiceDeletePopupComponent,
        InvoiceFinalizeDialogComponent,
        InvoiceFinalizePopupComponent,
        InvoiceReverseDialogComponent,
        InvoiceReversePopupComponent,
    ],
    providers: [
        InvoiceService,
        InvoicePopupService,
        InvoiceResolvePagingParams,
        PaymentUtilService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiInvoiceModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice/invoice.module.ts